import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const GET_TEMPLATES: DocumentNode = gql`
  query templates {
    templates {
      global {
        id
        name
        description
        template
        createdAt
        updatedAt
      }
      community {
        id
        name
        description
        template
        communityId
        createdAt
        updatedAt
        userId
      }
    }
  }
`;
